import { render, staticRenderFns } from "./NavigationTab.vue?vue&type=template&id=7685ebec"
import script from "./NavigationTab.vue?vue&type=script&lang=js"
export * from "./NavigationTab.vue?vue&type=script&lang=js"
import style0 from "./NavigationTab.vue?vue&type=style&index=0&id=7685ebec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports